module.exports = __webpack_public_path__ + "img/uav-r.6a549e0c.png";